export const FOOTER_TEXT = 'see some of our work';
